import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import BookingApp from './BookingApp.vue'
import BookingForm from './components/BookingForm.vue'
import BookingConfirmation from './components/BookingConfirmation.vue'
import messages from './i18n'
import { isEmbedMode, snapshotWpHandoffParams } from './utils/embedContext'
import { initEmbedBridge } from './embedBridge'

Vue.config.errorHandler = function (err, vm, info) {
  console.error('[booking-spa]', err, info)
}

// Capture WordPress handoff params before hash redirect can drop the query string.
snapshotWpHandoffParams()

initEmbedBridge()

if (isEmbedMode()) {
  document.documentElement.classList.add('is-booking-embedded')
  document.body.classList.add('is-booking-embedded')
}

// History-style URLs (/booking/:token): Laravel serves index.html; move path into the hash once.
;(function redirectBookingPathToHash () {
  var inner = (window.location.hash || '').replace(/^#/, '')
  if (inner.length > 0) return
  var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/'
  var base = '/booking'
  if (path.indexOf(base) !== 0) return
  var tail = path.slice(base.length).replace(/^\/+/, '')
  if (!tail || tail === 'index.html') return
  var search = window.location.search || ''
  window.location.replace(base + search + '#/' + tail)
})()

Vue.use(VueRouter)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages
})

const routes = [
  { path: '/', component: BookingForm },
  { path: '/confirmation', name: 'confirmation', component: BookingConfirmation, props: true },
  { path: '/:token', component: BookingForm, props: true }
]

// Hash mode: do not set base — page lives at /booking but routes live in the hash only.
// Using base: '/booking' with hash caused no match / blank router-view in this setup.
const router = new VueRouter({
  mode: 'hash',
  routes
})


new Vue({
  router,
  i18n,
  provide: {
    embedMode: isEmbedMode()
  },
  render: h => h(BookingApp)
}).$mount('#booking-app')



// WEBPACK FOOTER //
// ./src/main.js